<template lang="pug">
  v-app

    modals-controller
    chat-drawer
    the-app-bar
    navigation-drawer(
      v-if="$user.isAuthenticated"
    )

    v-main.v-main-custom
      loader-overlay

      portal-target(name="v-main")

      v-container(v-if="showEmailAlert").py-0
        v-alert(
          style="position: sticky; top: 60px; z-index: 0"
          type="error" small text rounded="xl" outlined
        )
          v-row.ma-0.align-center
            span Вы не подтвердили почтовый адрес
            v-spacer
            v-btn(small color="error" @click="openVerify") подтвердить
      //- permissions-wrapper(
      //-   :roles="[$conf.ROLES.teacher]"
      //-   v-slot:default
      //- )
        //- local-storage-dialog(title="Добро пожаловать в СДО!")
        //-   p С чего начать?
        //-   p Перейдите в раздел "
        //-     router-link(:to="{ name: 'UserSettings' }") Настройки пользователя
        //-     span " и укажите:
        //-   li часовой пояс;

      instruction-bottom-sheet(
        v-if="$route.meta.help"
        :id="$route.meta.help"
      )
      v-container.align-start(
        v-if="showBreadcrumbs"
      )
        v-row.ma-0
          v-breadcrumbs.pa-0(
            :items="breadcrumbs"
          )
          v-spacer
          portal-target(name="title")
        template(v-slot:divider)
          v-icon mdi-chevron-right

      v-container.align-start
        router-view

    v-footer(v-if="!$user.isAuthenticated")
      v-col.text-center(cols="12")
        v-btn(icon href="https://www.instagram.com/pfdo_2019" target="_blank")
          v-icon mdi-instagram
        v-btn(icon href="https://vk.com/publicpfdo" target="_blank")
          v-icon mdi-vk
        v-btn(icon href="https://play.google.com/store/apps/details?id=ru.pfdo.app.certificate&hl=en"  target="_blank")
          v-icon mdi-google-play
      v-col(cols="12" class="text-center pt-0")
        a.caption.secondary--text(
          href="/sdo-terms.pdf" target="_blank" style="text-decoration: none"
        )
          | Пользовательское соглашение
</template>

<script>
import breadcrumbsMixin from '@/mixins/breadcrumbs.mixin';

import LoaderOverlay from '@/components/Layout/LoaderOverlay.vue';
import ModalsController from '@/components/Layout/ModalsController/index.vue';
import NavigationDrawer from '@/components/Layout/NavigationDrawer/index.vue';
import TheAppBar from '@/components/Layout/TheAppBar.vue';
import ChatDrawer from '@/components/Layout/ChatDrawer.vue';

import InstructionBottomSheet from '@/modules/Instructions/components/InstructionBottomSheet.vue';
import LocalStorageDialog from '@/components/LocalStorageDialog.vue';

import UserVerifyModal from '../UserVerifyModal.vue';

export default {
  components: {
    TheAppBar,
    NavigationDrawer,
    InstructionBottomSheet,
    LocalStorageDialog,
    ModalsController,
    LoaderOverlay,
    ChatDrawer,
  },
  mixins: [breadcrumbsMixin],
  computed: {
    showEmailAlert() {
      const { data } = this.$user;
      return data && data.email && !data.email_verified_at && data.is_local;
    },
  },
  methods: {
    openVerify() {
      this.$modals.show('generic-controller', {
        component: UserVerifyModal,
      });
    },
  },
};
</script>
